import React, { Component } from 'react';
import { AppBar, Card, Divider, Typography, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const styles = theme => ({
    root: {}
});

class CompanyLinkWidget extends Component {

    render() {
        const { classes, auth } = this.props;
        const company_id = auth.user.data.role_info.link_id
        return (
            <Button
                onClick={() => this.props.history.push('/company/edit/' + company_id)}
                variant={'contained'}
            >
                To Company
            </Button>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth: auth,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyLinkWidget)));


// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/CompanyLinkWidget.js